import { wait } from '@change-corgi/core/async';

type PollUntilOptions = { interval?: number; timeout?: number; enabled?: boolean };
export async function pollUntil<T>(
	fn: () => Promise<T | undefined>,
	options: PollUntilOptions = {},
): Promise<T | undefined> {
	const { interval = 1000, timeout = 10000, enabled = true } = options;

	if (!enabled) return undefined;

	let stopped = false;

	const polling = async () => {
		while (!stopped) {
			// eslint-disable-next-line no-await-in-loop
			const [fnResult] = await Promise.allSettled([fn(), wait(interval)]);

			if (fnResult.status === 'fulfilled' && fnResult.value !== undefined) {
				stopped = true;
				return fnResult.value;
			}
		}
		return undefined;
	};

	return Promise.race([
		polling(),
		(async () => {
			await wait(timeout);
			stopped = true;
			return undefined;
		})(),
	]);
}
